export const rideTypeOptions = [
  //  { label: "City To Airport", value: "RideLater" },
  { label: "City To Airport", value: "CityToAirport" },
  { label: "Airport To City", value: "AirportPickup" },
];

// When "City To Airport" is selected, send these values to the API
export const CITY_TO_AIRPORT_API_VALUES = ["RideLater", "KurbPickup"];

export const bookingSourceOptions = [
  { label: "Driver App", value: "Partner" },
  { label: "Customer App", value: "Customer" },
  // { label: "Kiosk", value: "Kiosk" },
  { label: "Website", value: "Website" },
  { label: "TMS", value: "TMS" },
  { label: "WhatsApp", value: "WhatsApp" },
];

export const discountApplyOnOptions = [
  // { label: "BASE_FARE", value: "BASE_FARE" },
  { label: "ADDNL_PER_KM_CHARGE", value: "ADDNL_PER_KM_CHARGE" },
];

export const rewardTypeOptions = [
  // { value: "P", label: "Percentage" },
  { value: "F", label: "Flat Amount" },
];

export const paymentTypeOptions = [
  { value: "CreditCustomer", label: "Prepaid" },
  { value: "Cash", label: "Postpaid" },
];
